import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Problem } from './components/Problem';
import { SolutionIntro } from './components/SolutionIntro';
import { Framework } from './components/Framework';
import { Modules } from './components/Modules';
import { Dashboard } from './components/Dashboard';
import { ForWho } from './components/ForWho';
import { Integrations } from './components/Integrations';
import { CaseStudy } from './components/CaseStudy';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <div className="grain" data-id="element-1"></div>
      <Nav data-id="element-2" />
      <Hero data-id="element-3" />
      <TrustBar data-id="element-4" />
      <Problem data-id="element-5" />
      <SolutionIntro data-id="element-6" />
      <Framework data-id="element-7" />
      <Modules data-id="element-8" />
      <Dashboard data-id="element-9" />
      <ForWho data-id="element-10" />
      <Integrations data-id="element-11" />
      <CaseStudy data-id="element-12" />
      <Pricing data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}